exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wrapper-name[data-v-2375a65e]{display:flex;white-space:nowrap}.wrapper-name .name[data-v-2375a65e]{overflow:hidden;white-space:nowrap;text-overflow:ellipsis}", ""]);

// exports
